import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface NavItem {
  labelKey: string;
  sectionId: string;
}

@Component({
    selector: 'app-view-sidebar',
    imports: [CommonModule, TranslateModule],
    templateUrl: './view-sidebar.component.html',
    styleUrl: './view-sidebar.component.scss'
})
export class ViewSidebarComponent implements OnInit, OnDestroy {
  activeSectionId = 'company-profile';
  private scrollListener?: () => void;
  private mainContent: Element | null = null;

  readonly navItems: NavItem[] = [
    { labelKey: 'SIDEBAR.COMPANY_PROFILE', sectionId: 'company-profile' },
    { labelKey: 'SIDEBAR.SOLUTION_PORTFOLIO', sectionId: 'solution-portfolio' },
    { labelKey: 'SIDEBAR.VALUE_ANALYSIS', sectionId: 'roi-calculation' },
    { labelKey: 'SIDEBAR.DEMONSTRATION', sectionId: 'product-demos' },
    { labelKey: 'SIDEBAR.PROOFS', sectionId: 'use-cases' }
  ];
  
  constructor(private readonly ngZone: NgZone) {}

  ngOnInit(): void {
    setTimeout(() => this.initScrollListener(), 100);
  }

  ngOnDestroy(): void {
    this.removeScrollListener();
  }

  scrollToSection(sectionId: string): void {
    this.activeSectionId = sectionId;
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  private initScrollListener(): void {
    this.mainContent = document.querySelector('.main-content');
    if (!this.mainContent) return;
    
    this.scrollListener = () => {
      this.ngZone.run(() => {
        this.updateActiveSection();
      });
    };
    
    this.mainContent.addEventListener('scroll', this.scrollListener, { passive: true });
  }

  private removeScrollListener(): void {
    if (this.mainContent && this.scrollListener) {
      this.mainContent.removeEventListener('scroll', this.scrollListener);
    }
  }

  private updateActiveSection(): void {
    if (!this.mainContent) return;
    
    const scrollTop = this.mainContent.scrollTop;
    const offset = 150;
    
    for (let i = this.navItems.length - 1; i >= 0; i--) {
      const section = document.getElementById(this.navItems[i].sectionId);
      if (section) {
        const sectionTop = section.offsetTop - offset;
        if (scrollTop >= sectionTop) {
          this.activeSectionId = this.navItems[i].sectionId;
          return;
        }
      }
    }
    
    this.activeSectionId = this.navItems[0].sectionId;
  }
}
